// client/src/pages/Admin/Login/index.jsx
import { Form, useActionData, useNavigation } from 'react-router-dom';
import customFetch from '../../api/customFetch.js';


export const action = async ({ request }) => {
  const formData = await request.formData();
  const payload = Object.fromEntries(formData);

  // ולידציה בסיסית
  if (!payload.username || !payload.password) {
    toast.error('נא להזין שם משתמש וסיסמה');
    return null;
  }

  try {
    await customFetch.post('/users/admin-login', payload);
    toast.success('ההתחברות בוצעה בהצלחה');
    return redirect('/admin/courses');
  } catch (error) {
    console.log('Admin login error:', error);
    
    toast.error(error?.response?.data?.message || 'שגיאה בהתחברות');
    return null;
  }
};

export default function AdminLogin() {
  const actionData = useActionData();
  const navigation = useNavigation();
  const isSubmitting = navigation.state === 'submitting';

  return (
    <Form method="post" dir="rtl" className="form" style={{ maxWidth: 600, margin: '100px auto' }}>
      <h2>התחברות מנהל</h2>

      {actionData?.message && (
        <div style={{
          background: '#ffebe9',
          color: '#86181d',
          padding: '10px 12px',
          borderRadius: 12,
          marginBottom: 12,
          border: '1px solid #ffd1d1'
        }}>
          {actionData.message}
        </div>
      )}

      <input
        name="username"
        type="text"
        placeholder="שם משתמש"
        aria-invalid={!!actionData?.fieldErrors?.username}
        aria-describedby="email-error"
        style={{ marginBottom: 8 }}
      />
      {actionData?.fieldErrors?.username && (
        <div id="username-error" style={{ color: '#ff6b6b', marginBottom: 8 }}>
          {actionData.fieldErrors.username}
        </div>
      )}

      <input
        name="password"
        type="password"
        placeholder="סיסמה"
        aria-invalid={!!actionData?.fieldErrors?.password}
        aria-describedby="password-error"
        style={{ marginBottom: 8 }}
      />
      {actionData?.fieldErrors?.password && (
        <div id="password-error" style={{ color: '#ff6b6b', marginBottom: 8 }}>
          {actionData.fieldErrors.password}
        </div>
      )}

      <button className="btn" disabled={isSubmitting}>
        {isSubmitting ? 'מתחבר…' : 'התחבר'}
      </button>
    </Form>
  );
}